interface IFixedRightBottom {
  backTop?: {
    scrollContainer: string
    item: string
    top?: number
    total?: Ref<number> | number
  }
  // contactUs: boolean
  onlineService: boolean
}

export const useFixedRightBottom = () =>
  useState<IFixedRightBottom>('fixed-right-bottom', () => ({
    // contactUs: true,
    onlineService: true,
  }))

export const useBackToTop = (fn: () => IFixedRightBottom['backTop']) => {
  const option = useFixedRightBottom()

  let tid: NodeJS.Timeout
  const asyncBind = () => {
    if (tid) {
      clearTimeout(tid)
    }
    option.value.backTop = undefined
    // 当 watch effect 发生时，由于前后的元素可能是同一个元素，所以如果只是单纯执行方法的返回，会由于同一个元素，导致滚动的监听无法重新绑定。
    nextTick(() => {
      tid = setTimeout(() => {
        option.value.backTop = fn()
      })
    })
  }

  watchEffect(() => {
    asyncBind()
  })

  onBeforeRouteLeave(() => {
    option.value.backTop = undefined
  })

  return {
    asyncBind,
  }
}
